import store from '@/store';
import { isElectron } from '@/utils/electron';
import { isWorkBuddyClient } from '@/utils/embedEntry';

/**
 * @description: keepAlive缓存处理
 * @param {Object} to
 * @param {Object} from
 * @param {Function} next
 * @return {void}
 */
export default (to, from) => {
  const formParentPath = from.meta.otherParent || [];
  if (to.path === from.path) return;
  // 判断是否是从下级页面返回
  if ((from.meta.parent === to.path || formParentPath.includes(to.path)) && to.meta.componentName) {
    // 从下级页面返回则删除缓存
    setTimeout(() => {
      store.commit('removeKeepAlive', to.meta.componentName);
    }, 500);
    return;
  }

  // 判断to的meta是否有父级页面 没有则说明不同链路 清空已缓存
  const toParentPath = to.meta.parent;
  // 是否存在公共父级页面
  const toOtherParent = to.meta.otherParent || [];
  if (!toParentPath && !toOtherParent.length) {
    // Electron / WorkBuddy 客户端需保留缓存，避免跨链路切换时误清 keepAlive
    if (!isElectron && !isWorkBuddyClient()) store.commit('clearKeepAlive');
    return;
  }

  // 判断是否同一链路
  if ((toParentPath === from.path || toOtherParent.includes(from.path)) && from.meta.componentName) {
    store.commit('pushKeepAlive', from.meta.componentName);
  }
};
